import React from 'react';
import { Card, Form, Select, Switch, Button, Typography, Space, message } from 'antd';
import { useTranslation } from 'react-i18next';
import { useAppStore } from '../store';

const { Title } = Typography;
const { Option } = Select;

const Settings: React.FC = () => {
  const { t, i18n } = useTranslation();
  const { theme, language, setTheme, setLanguage } = useAppStore();
  const [form] = Form.useForm();

  const handleLanguageChange = (value: 'zh' | 'en') => {
    setLanguage(value);
    i18n.changeLanguage(value);
    message.success(t('common.success'));
  };

  const handleThemeChange = (checked: boolean) => {
    const newTheme = checked ? 'dark' : 'light';
    setTheme(newTheme);
    message.success(t('common.success'));
  };

  const handleReset = () => {
    setLanguage('zh');
    setTheme('light');
    i18n.changeLanguage('zh');
    form.resetFields();
    message.success('设置已重置');
  };

  return (
    <div className="max-w-2xl mx-auto">
      <Title level={2} className="!mb-6">
        {t('settings.title')}
      </Title>

      <Card className="!mb-6">
        <Title level={4} className="!mb-4">
          {t('settings.language')}
        </Title>
        
        <Form
          form={form}
          layout="vertical"
          initialValues={{
            language,
            theme: theme === 'dark',
          }}
        >
          <Form.Item
            label="界面语言"
            name="language"
          >
            <Select
              value={language}
              onChange={handleLanguageChange}
              className="w-48"
            >
              <Option value="zh">中文</Option>
              <Option value="en">English</Option>
            </Select>
          </Form.Item>

          <Form.Item
            label={t('settings.theme')}
            name="theme"
            valuePropName="checked"
          >
            <Switch
              checked={theme === 'dark'}
              onChange={handleThemeChange}
              checkedChildren="深色"
              unCheckedChildren="浅色"
            />
          </Form.Item>
        </Form>
      </Card>

      <Card>
        <Title level={4} className="!mb-4">
          其他设置
        </Title>
        
        <div className="space-y-4">
          <div className="flex justify-between items-center">
            <span>自动保存</span>
            <Switch defaultChecked />
          </div>
          
          <div className="flex justify-between items-center">
            <span>消息通知</span>
            <Switch defaultChecked />
          </div>
          
          <div className="flex justify-between items-center">
            <span>数据分析</span>
            <Switch />
          </div>
        </div>

        <div className="mt-6 pt-4 border-t border-gray-200">
          <Space>
            <Button type="primary">
              {t('common.save')}
            </Button>
            <Button onClick={handleReset}>
              {t('common.reset')}
            </Button>
          </Space>
        </div>
      </Card>
    </div>
  );
};

export default Settings;
